export default __webpack_public_path__ + "static/media/Raleway-Medium.346d4988.woff2";